import axios from "axios";
import {hostWithPrefix} from "../Constructor/common/ApiCommon";

export function getSystemSection(start, end, startId, selectedIds) {
    return  axios({
        url: 'http://' + hostWithPrefix + '/monitoring/system?' +
            'startStr=' + start +
            '&endStr=' + end +
            '&startId=' + startId +
            '&ids=' + selectedIds,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    })
}

export function getStationSection(start, end, stationId) {
    return  axios({
        url: 'http://' + hostWithPrefix + '/monitoring/station?' +
            'startStr=' + start +
            '&endStr=' + end +
            '&stationId=' + stationId,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    })
}

export function getDatasourceSection(start, end, stationId, datasourceId) {
    return  axios({
        url: 'http://' + hostWithPrefix + '/monitoring/datasource?' +
            'startStr=' + start +
            '&endStr=' + end +
            '&stationId=' + stationId +
            '&datasourceId=' + datasourceId,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    })
}

export function getEntitySection(start, end, stationId, datasourceId, entityId) {
    return  axios({
        url: 'http://' + hostWithPrefix + '/monitoring/entity?' +
            'startStr=' + start +
            '&endStr=' + end +
            '&stationId=' + stationId +
            '&datasourceId=' + datasourceId +
            '&entityId=' + entityId,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    })
}

export function getIdNameMapping() {
    return  axios({
        url: 'http://' + hostWithPrefix + '/monitoring/stationIdNameMapping',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    })
}

export function getDatasourceIdNameMapping() {
    return  axios({
        url: 'http://' + hostWithPrefix + '/monitoring/datasourceIdNameMapping',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    })
}

export function getMeteocodeIdNameMapping() {
    return  axios({
        url: 'http://' + hostWithPrefix + '/monitoring/meteocodeIdNameMapping',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    })
}

export function getEntityIdNameMapping() {
    return  axios({
        url: 'http://' + hostWithPrefix + '/monitoring/entityIdNameMapping',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    })
}

export function getPhotoRecorderIds() {
    return  axios({
        url: 'http://' + hostWithPrefix + '/monitoring/photos',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    })
}

export function getDatasourceOnTypeMapping() {
    return  axios({
        url: 'http://' + hostWithPrefix + '/monitoring/datasourceOnTypeMapping',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    })
}